export function buildRencanaAksiFormData(form, { isUpt = false } = {}) {
  const formData = new FormData()
  formData.append('no_kkprl', form.no_kkprl)
  formData.append('jenis_kegiatan', form.jenis_kegiatan)
  formData.append('nama_pemegang', form.nama_pemegang)
  formData.append('npwp', form.npwp)
  formData.append('nib', form.nib)
  ;(form.provinsi || []).forEach((item) => {
    formData.append('provinsi', item)
  })
  formData.append('tanggal_terbit', form.tanggal_terbit)
  formData.append('jenis_rencana_aksi', form.jenis_rencana_aksi)
  formData.append('metode_penilaian_pelaksanaan', form.metode_penilaian_pelaksanaan)
  formData.append('prioritas', form.prioritas === true ? 'true' : 'false')
  formData.append('tanggal_penilaian', form.tanggal_penilaian)
  formData.append('lokasi_penilaian', form.lokasi_penilaian)
  ;(form.id_tim_penilai || []).forEach((item) => {
    formData.append('id_tim_penilai', item)
  })
  formData.append('is_upt', isUpt ? 'true' : 'false')
  return formData
}
